<template>
  <v-container
    id="new-purchase"
    align-start
    fill-height
    fluid
    pa-0>
    <FormPurchase
      v-if="step == 1"
      :app="app"
      :change-step="changeStep"/>
    <RefinePurchase
      v-if="step == 2"
      :app="app"
      :change-step="changeStep"
      mode="purchase"/>
    <CheckPurchase
      v-if="step == 3"
      :app="app"
      @changeStep="changeStep"/>
  </v-container>
</template>
<script>
import FormPurchase from 'pages/purchase/new purch/FormPurchase.vue'
import RefinePurchase from 'pages/purchase/new purch/RefinePurchase.vue'
import CheckPurchase from 'pages/purchase/new purch/CheckPurchase.vue'

import { eventBus } from '@/main'

export default {
  name: 'newPurchase',
  data() {
    return {
      step: 1,
      app: null,
    }
  },
  async created() {
    if (this.$route?.query?.id) {
      this.step = +this.$route?.query?.step || 2
      this.app = +this.$route?.query?.id
    } else if (+this.$route?.query?.step !== 1) {
      this.$router.push({ name: 'catalog', params: {org: this.$route.params.org}, query: { step: 1 }})
    }
    eventBus.$emit('finishLoadingContent', ['setPurchaseSettings'])
  },
  methods: {
    async changeStep(next, app) {
      if (app) {
        this.app = app.id || app
      }

      let step = next ? this.step + 1 : this.step - 1
      if (step == 4 || step == 0) {
        this.$router.push({name: 'purchasing', params: {org: this.$route.params.org } })
      } else if ( app || this.app ) {
        this.$router.push({name: this.$route.name, query: {step: step, id: this.app}, params: { org: this.$route.params.org }})
      }
      this.step = step
    }
  },
  components: {
    FormPurchase,
    CheckPurchase,
    RefinePurchase
  }
}
</script>
